import { render, staticRenderFns } from "./MarketingAndUpsell.vue?vue&type=template&id=49ba7c99&scoped=true"
import script from "./MarketingAndUpsell.vue?vue&type=script&lang=js"
export * from "./MarketingAndUpsell.vue?vue&type=script&lang=js"
import style0 from "./MarketingAndUpsell.vue?vue&type=style&index=0&id=49ba7c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ba7c99",
  null
  
)

export default component.exports